<template lang="html">
    <v-form ref="form" >
        <v-container grid-list-xs>
            <v-layout wrap>
                <!-- convert projet modal, in multiple step -->

                <!-- #region - step 1 -- select supplier product -->
                <v-flex v-if="this.step===1" xs12>
                    <v-select
                        label="Produit Fournisseur"
                        autocomplete
                        required
                        chips
                        clearable
                        :items="supplier_products"
                        item-text="label"
                        item-value="id"
                        :rules="rules.supplier_product"
                        v-model="supplier_product"
                        @change=""
                        >
                        <template slot="selection" slot-scope="data">

                            {{ data.item.label }}

                        </template>
                        <template slot="item" slot-scope="data">
                            <template v-if="typeof data.item === 'object'">
                                <v-avatar>
                                    <img :src="supplier_product_avatar(data)"/>
                                </v-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ data.item.label }}</v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                    </v-select>
                </v-flex>
                <!-- #endregion -->


                <!-- #region - step 2 -- check the artcle code -->
                <v-flex xs12 v-if="step===2">
                    <v-layout>
                        <v-flex xs12>
                            <v-form v-model="code_ok">
                                <v-text-field
                                label="Code article"
                                v-model="product_code"
                                required
                                :color="ERP_color"
                                :loading="ERP_loading"
                                :error="ERP_error"
                                :hint="ERP_message"
                                :rules="rules.product_code"
                                >
                                </v-text-field>
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <!-- #endregion -->


                <!-- #region - step 3 -- export requests & comments -->
                <v-flex xs12 v-if="step===3">
                    <data-table
                        :headers="datatable.headers"
                        :endpoint="datatable.endpoint"
                        storeId="comments"
                        ref="list"
                    >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-right">
                            <v-checkbox hide-details v-model="props.item.request_selected" @change="setRequest(props.item)" color="accent"></v-checkbox>
                        </td>
                        <td class="text-xs-right">
                            <v-checkbox hide-details v-model="props.item.comment_selected" @change="setComment(props.item)" color="accent"></v-checkbox>
                        </td>
                        <td class="text-xs-right">
                            {{props.item.user.first_name}} {{props.item.user.last_name}}
                        </td>
                        <td class="text-xs-right">
                            {{moment(props.item.created_at).format('DD/MM/YYYY')}}
                        </td>
                        <td class="text-xs-center">
                            <v-icon :style="{color: getCommentColor(props.item.type)}">fiber_manual_record</v-icon>
                        </td>
                        <td class="text-xs-right">
                            {{props.item.message}}
                        </td>
                    </template>
                    </data-table>
                </v-flex>
                <!-- #endregion -->


                <!-- #region - step 4 - loading -- convert -->
                <div class="loader" v-if="step === 4">
                    <img src="../../../assets/img/grid_loader.svg" />
                    <p>Conversion du projet en cours</p>
                </div>
                <!-- #endregion -->


            </v-layout>
        </v-container>
    </v-form>
</template>


<script>
import DataTable from '../../../components/DataTable.vue'
import { CommentTypes } from '../../../config/enum/CommentTypes'
import moment from 'moment'

export default {
    components: { DataTable },
	props: {
		params: {
			required: true
		}
	},
	data() {
		return {
		    moment,
            title: 'Convertir un Projet',
            width: '1000px',
            supplier_product: '',
            product_code: '',
            model: {},
            code_ok: false,
            code_accepted: false,

            ERP_color: 'primary',
            ERP_error: false,
            ERP_message: null,
            ERP_loading: false,

            step: 1,
            valid_button: false,
            next_button: true,
            comments: [],
            requests: [],
            created_product_id: '',
            rules: {
                supplier_product: [
                    (v) => !!v || 'Produit Fournisseur obligatoire',
                ],
                product_code: [
                    (v) => !!v && !isNaN(v) && v.length > 5 || 'Code de 6 chiffres obligatoire',
                ]
            },
            datatable: {
                headers: [
                    { text: 'Demandes', sortable: false, value: 'is_request', align: 'right' },
                    { text: 'Commentaires', sortable: false, value: 'is_comment', align: 'right' },
                    { text: 'Auteur', sortable: true, value: 'user_id', align: 'right' },
                    { text: 'Date', sortable: true, value: 'created_at', align: 'right' },
                    { text: 'Tonalite', sortable: false, value: 'type', align: 'center' },
                    { text: 'Message', sortable: false, align: 'right' }
                ],
                endpoint: {
                    base: '/api/comments',
                    filters: 'product_id|=|',
                    embed: 'user'
                }
            }
        }
    },
    created() {
        this.$eventHub.$emit('set-valid-button', false);
    },
    computed: {
        supplier_products: function() {
            return this.$store.state.single.data.supplier_products;
        }
    },
    watch: {
        code_ok: function(val) {
            if (val) {
                this.sendCode(this.product_code);
            }
        }
    },

    methods: {
        supplier_product_avatar(data) {
            if (data.item.photo === null) {
                return require('../../../assets/img/defaultProduct.png');
            } else {
                return data.item.photo
            }
        },

        sendCode(value) {
            this.ERP_loading = true

            this.axios.get(`/api/products/erp-synchro/${value}`)
                .then(res => {
                    this.ERP_error   = false
                    this.ERP_color   = 'success'
                    this.ERP_loading = false
                    this.ERP_message = res.data.label

                    this.code_accepted=true;
                    this.$eventHub.$emit('set-next-button', true)

                })
                .catch(err => {
                    if(err.response.data.status_code == 422) {
                        this.ERP_color   = 'primary'
                        this.ERP_error   = true
                        this.ERP_loading = false
                        this.ERP_message = err.response.data.message

                    } else {
                        console.log(err.response.data)
                    }

                    this.$eventHub.$emit('set-next-button', false);
                    this.code_accepted=false;
                });
        },

        setComment(item) {
            let index = this.comments.indexOf(item.id)

            if(item.comment_selected) {
                if(index == -1) {
                    this.comments.push(item.id)
                }

            } else {
                if(index > -1) {
                    this.comments.splice(index, 1)
                }
            }
        },

        setRequest(item) {
            let index = this.requests.indexOf(item.id)

            if(item.request_selected) {
                if(index == -1) {
                    this.requests.push(item.id)
                }

            } else {
                if(index > -1) {
                    this.requests.splice(index, 1)
                }
            }
        },

        getCommentColor: function(type) {
            let commentType = CommentTypes.find((el) => {
                return el.value === type
            });
            return commentType ? commentType.color : '';
        },

        onClose() {
            this.$eventHub.$emit('close-modal')
        },

        onNextStep() {
            if(this.step === 1 && this.supplier_product !== null && this.supplier_product !== '') {
                this.step++;
                this.$eventHub.$emit('set-next-button', false);
                this.datatable.endpoint.filters += this.supplier_product;

            } else if (this.step === 2 && this.code_accepted) {
                this.$eventHub.$emit('set-next-button', false);
                this.$eventHub.$emit('set-valid-button', true);

                this.step++;
            }
        },

        onValidate() {

            this.step++;
            this.$eventHub.$emit('hide-modal-actions');

            this.axios.post('/api/products/erp-synchro', {
                    num: this.product_code,
                    root_product_id: this.supplier_product,
                    comment_ids: this.comments,
                    request_ids: this.requests,
                })
                .then(res  => {

                    let interval = setInterval(() => {

                        this.axios.get(`/api/products/${res.data.id}`)
                            .then(r => {
                                if(!r.data.is_syncing) {
                                    clearInterval(interval)

                                    this.$eventHub.$emit('close-modal');

                                    this.$router.push({
                                        name: 'single-product',
                                        params: {
                                            super_family: this.$store.state.single.data.category.parent.parent.label,
                                            id: res.data.id
                                        }
                                    })
                                }
                            })

                    }, 3000);

                })
                .catch(err  => console.log(err.response.data))

        }


    }
}
</script>

<style lang="stylus" scoped>


    .icon-flex-container {
        display: flex

        .code-input-icon-container {
            display: flex
            justify-content: space-around
            flex: 1
            vertical-align: center
            text-align: center
        }
    }

    .loader
        display flex
        flex-direction column
        align-items center
        width 100%
        padding 3rem 0

        img
            margin 0 0 3rem

</style>



// WEBPACK FOOTER //
// src/views/projects/single/ConvertProject.vue